import { render, staticRenderFns } from "./ItineraryPage.vue?vue&type=template&id=60837c01&scoped=true&"
import script from "./ItineraryPage.vue?vue&type=script&lang=js&"
export * from "./ItineraryPage.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryPage.vue?vue&type=style&index=0&id=60837c01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60837c01",
  null
  
)

export default component.exports